import React, { useState } from 'react'
import { BGFields } from './PriceAndArchitecture';
import { useTheme } from '../../../middleware/ThemeContext';
import StyledText from '../../../components/StyledComponents/StyledText';
import FormikInputField from '../../../components/Formik/FormikInputField';
import FormikSelect from '../../../components/Formik/FormikSelect';
import { MembershipTypeFormValues } from '../../../types/types';
import { FormActions } from '../../../components/FormBuilder/CustomForm/FormFiller';
import { Button } from '../../../components/form/Button';
import CloseIcon from '../../../assets/icons/CloseIcon';

interface AddFeeSettingsProps {
    close: () => void;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    values: MembershipTypeFormValues;
}

const AddFeeSettings:React.FC<AddFeeSettingsProps> = ({ values, setFieldValue, close }) => {
    const {theme} = useTheme();

    const [feeName, setFeeName] = useState<string>('');
    const [feeType, setFeeType] = useState<string>('');
    const [feeAmount, setFeeAmount] = useState<number>(0);
    const [appliesDuring, setAppliesDuring] = useState<string>('');
    const [recurring, setRecurring] = useState<string>('');

    const [errors, setErrors] = useState({
        feeName: "",
        feeType: "",
        feeAmount: "",
        appliesDuring: "",
        recurring: "",
    });

    const validateForm = () => {
        const newErrors = {
            feeName: "",
            feeType: "",
            feeAmount: "",
            appliesDuring: "",
            recurring: "",
        };

        if(!feeName){
            newErrors.feeName = "Please add fee name";
        }

        if(!feeType){
            newErrors.feeType = "Please select fee type";
        }

        if(!feeAmount){
            newErrors.feeAmount = "Please add fee amount";
        }
        
        if(!appliesDuring){
            newErrors.appliesDuring = "Please select applies during";
        }

        if(!recurring){
            newErrors.recurring = "Please select recurring";
        }

        setErrors(newErrors);

        return !Object.values(newErrors).some(Boolean);
    }

    const addFee = () => {
        // if(feeName && feeType && feeAmount > 0 && appliesDuring && recurring) {

        const isValid = validateForm();

        if (!isValid) return;
            
            const newFee = {
                feeName: feeName,
                feeType: feeType,
                feeAmount: feeAmount,
                applyFeeTo: appliesDuring,
                frequency: recurring,
            };
            
            setFieldValue("additionalFeeSettings", [
            ...values.additionalFeeSettings,
            newFee
            ]);

            setFeeName("");
            setFeeType("");
            setFeeAmount(0);
            setAppliesDuring("");
            setRecurring("");

            close();

        // } else {
        //     console.log('Please fill all fields to add fee');
        // }
    };
  return (
    <BGFields theme={theme}>
            <div className='mb-3'>
                <StyledText
                    className=" mb-2"
                    textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                    Fee Name
                </StyledText>
                <FormikInputField
                    // className='mb-3'
                    name="feeName"
                    type='text'
                    placeholder="Enter Fee Name"
                    onChange={(e) => {
                        setFeeName(e.target.value);
                        setErrors((prev) => ({
                            ...prev,
                            feeName: "",
                        }));
                    }}
                />
                <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor="red"
                >
                    {errors.feeName}
                </StyledText>
            </div>

            <div className='mb-3'>
                <StyledText
                    className=" mb-2"
                    textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                    Fee Type
                </StyledText>
                <FormikSelect
                    // className={`mb-3`}
                    options={[
                        { label: "Percentage", value: "percentage" },
                        { label: "Fixed", value: "fixed" },
                    ]}
                    name="feeType"
                    placeholder="Select fee type"
                    onChange={(
                        val:
                            | string
                            | { label: string; value: number | string }
                    ) => {
                        const value =
                            typeof val === "string" ? val : String(val.value);
                        setFeeType(value);
                        setErrors((prev) => ({
                            ...prev,
                            feeType: "",
                        }));
                    }}
                />
                <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor="red"
                >
                    {errors.feeType}
                </StyledText>
            </div>

            <div className='mb-3'>
                <StyledText
                    className=" mb-2"
                    textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                    Fee Amount
                </StyledText>
                <FormikInputField
                    // className='mb-3'
                    name="feeAmount"
                    type='number'
                    min={0}
                    placeholder="Enter Fee Amount"
                    onChange={(e) => {
                        setFeeAmount(Number(e.target.value));
                        setErrors((prev) => ({
                            ...prev,
                            feeAmount: "",
                        }));
                    }}
                    suffix={feeType === 'percentage' ? '%' : feeType === 'fixed' ? '$' : ''}
                />
                <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor="red"
                >
                    {errors.feeAmount}
                </StyledText>
            </div>

            <div className='mb-3'>
                <StyledText
                    className=" mb-2"
                    textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                    Applies During
                </StyledText>
                <FormikSelect
                    // className={`mb-3`}
                    options={[
                        { label: "Join", value: "join" },
                        { label: "Renewal", value: "renewal" },
                        { label: "Both", value: "both" },
                    ]}
                    name="appliesDuring"
                    placeholder="Select applies during"
                    onChange={(
                        val:
                            | string
                            | { label: string; value: number | string }
                    ) => {
                        const value =
                            typeof val === "string" ? val : String(val.value);
                        setAppliesDuring(value);
                        setErrors((prev) => ({
                            ...prev,
                            appliesDuring: "",
                        }));
                    }}
                />
                <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor="red"
                >
                    {errors.appliesDuring}
                </StyledText>
            </div>

            <div className='mb-3'>
                <StyledText
                    className=" mb-2"
                    textColor={theme.CorporateTheme?.colors?.headerColor}
                >
                    Recurring
                </StyledText>
                <FormikSelect
                    // className={`mb-3`}
                    options={[
                        { label: "One Time", value: "one_time" },
                        { label: "Every Renewal", value: "recurring" },
                    ]}
                    name="recurring"
                    placeholder="Select recurring"
                    onChange={(
                        val:
                            | string
                            | { label: string; value: number | string }
                    ) => {
                        const value =
                            typeof val === "string" ? val : String(val.value);
                        setRecurring(value);
                        setErrors((prev) => ({
                            ...prev,
                            recurring: "",
                        }));
                    }}
                />
                <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor="red"
                >
                    {errors.recurring}
                </StyledText>
            </div>

            <FormActions>
            <Button 
                theme={theme} 
                type="button" 
                $variant="cancel" 
                onClick={close} 
            >
              <CloseIcon color={theme.CorporateTheme.colors.textSecondary} /> Close
            </Button>
            <Button 
                theme={theme} 
                type="button" 
                $variant="customize" 
                onClick={() => addFee()} 
                // disabled={isLoading || isUpdating}
            >
              {/* <DocumentIcon color={theme.CorporateTheme.colors.background} /> */}
                Create Fee
              {/* {mode === 'edit' ? (isUpdating ? 'Saving...' : 'Save Changes') : (isLoading ? 'Creating...' : 'Create Form')} */}
            </Button>
          </FormActions>

        </BGFields>
  )
}

export default AddFeeSettings